import * as React from "react";
import {  Modal,Button} from "antd";
import { connect } from "react-redux";

interface ITestProps {
  id:any;
  submitTag:any;
  getOrderDetails:any;
}

// 确认函
class Test extends React.Component<ITestProps, any> {
  state = {
    content:'',
    visible:false,
  };
  constructor(props: ITestProps) {
    super(props);
  }


  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
 
  onOk= () =>{
    const param: any = {
      id: this.props.id,
      type: 'test'
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          this.handleCancel();
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
              console.log(this.props);
            }
           });
      }
     }); 
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }


  render() {
    const buttonStyle = {
      backgroundColor: "#fff",
      color:"#000",
      border:'none',
      display: 'block',
    };
    return (
      <React.Fragment>
         <Button style={buttonStyle} onClick={this.show.bind(this,this.props.id)}>测试</Button> 
     <Modal maskClosable={false} onOk={this.onOk} onCancel={this.handleCancel} title="标记测试"  visible={this.state.visible}  width="auto" centered={true}>
          <div className="abnormal">
              确定对当前单标记为测试吗？
          </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Test);
